export default __webpack_public_path__ + "images/5cab1f025d4a9fc3834ee8c75deef359.svg";